import { RankingListProps } from '@apps/containers/RankingList/props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const RankingList: React.FC<RankingListProps> = (props) => {
  const { data, renderItem } = props;
  // ============ VIEWS
  return (
    <>
      {data?.map((item, index) => {
        const rank = index + 1;
        return renderItem({ ...item, rank });
      })}
    </>
  );
};

/**
 * ===========================
 * EXPORT
 * ===========================
 */
export default RankingList;
